import Backbone from "backbone";

import * as mustcache from "mustcache";
import * as textToSpeech from "textToSpeech";

const ToggleSpeakingModeView = Backbone.View.extend({
  initialize: function () {
    // model is the user
    this.render();
    this.listenTo(
      this.model,
      "change:currentLearningLanguage change:speakingMode",
      this.render.bind(this)
    );
  },
  attributes: {
    class: "toggleSpeakingModeButton",
  },
  render: function () {
    if (
      textToSpeech.languageSupported(this.model.get("currentLearningLanguage"))
    ) {
      mustcache.render(
        "toggleSpeakingModeButton",
        { on: this.model.get("speakingMode") },
        (html) => {
          if (this.model.get("speakingMode")) {
            this.$el.attr("title", "Click to turn off Speaking Mode");
          } else {
            this.$el.attr("title", "Click to turn on Speaking Mode");
          }
          this.$el.html(html);
        }
      );
    } else {
      this.$el.empty();
    }
  },
  events: {
    click: "toggleSpeakingMode",
  },
  toggleSpeakingMode: function () {
    this.model.save(
      {
        speakingMode: !this.model.get("speakingMode"),
      },
      { patch: true },
      () => {}
    );
    if (this.model.get("speakingMode")) {
      this.trigger("speak");
    }
  },
});

export default ToggleSpeakingModeView;
